import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t } = useTranslation();

  return (
    <header>
      <nav>
        <Link to="/" className="logo">
          <img src="/images/logo.png" alt="MoleCorp Logo" />
          MoleCorp
        </Link>
        <ul className="nav-links">
          <li><Link to="/">{t('nav.home')}</Link></li>
          <li><Link to="/about">{t('nav.about')}</Link></li>
          <li><Link to="/services">{t('nav.services')}</Link></li>
          <li><Link to="/contact">{t('nav.contact')}</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;

